import { createTheme } from '@mui/material/styles';
import { Theme } from '@mui/styles';
import { grey } from "@mui/material/colors";

// These are here to load the renderers
// By putting them here, they are accessible throughout the application, invlucing the testing apps.
import RemitVendorSuggestionRenderer from "~invoice-processing/components/remit-vendor-suggestion-renderer";
RemitVendorSuggestionRenderer.register();

// USF Branding
export const primaryColor = "#1f1f1f";
export const newColor = "#56821f";

export const raisedButtonPrimary = "#56821f"; // green
export const secondaryColor = "#cf4520"; // orange
export const raisedButtonContained = "#c08b0b"; // bright gold
export const raisedButtonContainedDefault = "#bdbdbd";
import PortalUserContext from "~common/lib/portal-user-context";

import OutOfOfficeAlternatePreferences from "~users/components/out-of-office-alternate-preferences";
OutOfOfficeAlternatePreferences.register()

declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
      default: true;
  }
}

declare module '@mui/styles' {
  interface DefaultTheme extends Theme {}
}

declare module "@mui/material" {
  interface Color {
      main: string;
      dark: string;
  }
}

const isLoggedIn = PortalUserContext.isLoggedIn();

export const logoFileName = "/static/assets/usf-logo.png";

export const formBasedTaskContainerFixedToolbarStyle = {
  position: "fixed",
  top: 170,
  height: "100%",
  width: "auto",
  paddingRight: 10,
  overflow: "scroll",
};



export const theme = createTheme({
  palette: {
    mode: "light",
    default: {
      main: grey[300],
      dark: grey[400]
    },
    primary: {
      main: primaryColor,
    },
    secondary: {
      main: secondaryColor,
    },
  },
  scrollToTopArrow: {
    color: primaryColor,
  },
  typography: {
    fontFamily: ["Roboto", "Arial", "sans-serif"].join(","),
  },
  components: {
    MuiTextField: {
      defaultProps: {
        variant: 'standard'
      }
    },
    MuiFormControl: {
      defaultProps: {
        variant: 'standard'
      }
    },
    MuiFormSelect: {
      defaultProps: {
        variant: 'standard'
      }
    },
    MuiAppBar: {
      defaultProps: {
      style: {
          background: "linear-gradient(0deg, #ffffff 0%, #fefefe 100%)",
          color: "#56821f",
        }
      }
    },
    MuiBadge: {
      defaultProps: {
        color: "primary"
      }
    },
    MuiSwitch: {
      defaultProps: {
      root: {
        "&$checked": {
          color: "#56821f !important",
          // TODO: MGM Original
          // color: '#835e12 !important'
        },
      },
    }
    },
    MuiFormLabel: {
      defaultProps: {
        sx: {'& .MuiFormLabel-asterisk': {'color': 'red'}, color: 'rgba(0, 0, 0, 0.8)'}
      }
    },
    MuiTypography: {
      defaultProps: {
        display1: {
          fontSize: "1.75rem",
          fontWeight: 500,
          lineHeight: "1.20588em",
          marginBottom: 15,
          color: "rgba(0, 0, 0, 0.54)",
      },
      subheading: {
        color: primaryColor,
      },
    }
    },
    MuiListSubheader: {
      defaultProps: {
      sticky: {
        backgroundColor: "#fff",
      },
    }
    },
    MuiMobileStepper: {
      defaultProps: {
      root: {
        backgroundColor: "#fff",
      },
    }
    },
    MuiTableCell: {
      defaultProps: {
      root: {
        borderBottom: "0px",
      },
    }
    },
    MenuDrawer: {
      defaultProps: {
        menuItem: {
          color: '#222'
        }
      }
    },
    MuiAccordion: {
      defaultProps: {
        root: {
          padding: '0px 0px 0px 0px'
        }
      }
    },
    MuiAccordionSummary: {
      defaultProps: {
        root: {
          padding: '0px 0px 0px 0px'
        }
      }
    }
  },
});
var root: any = {
  paddingTop: 75,
  paddingLeft: 15,
  paddingRight: 15,
};

if (!isLoggedIn) {
  root = {
    paddingTop: 75,
    paddingLeft: 0,
    paddingRight: 0,
  };
}

export const styleRules = {
  root: root,
  appBarButton: {
    // This is primarily the login button in the upper right when not logged in.
    // TODO: MGM Original
    // color: "#757575",
    color: "#56821f",
  },
  toolbar: {
    "@media only print": { display: "none" },
  },
  flex: {
    flex: 1,
  },
  appTitle: {
    flex: 1,
    color: "#fff",
    marginTop: 5,
    fontFamily: "Arial,san-serif,Helvetica,Trebuchet MS",
  },
  drawerList: {
    width: 250,
  },
  menuButton: {
    // TODO: MGM Original
    // color: "#996D15 !important",
    color: "#56821f !important",
    marginLeft: -12,
    marginRight: 0,
  },
  logo: {
    marginLeft: 10,
    marginTop: 0,
    height: 40,
    width: "auto",
  },
  bottomPadding: {
    height: 60,
  },
  // chip: {
  //   margin: theme.spacing(1)
  // },
  homeIcon: {
    marginRight: 10,
  },
};
